import _asyncToGenerator from "/opt/atlassian/pipelines/agent/build/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.split.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import { ModalComponents, ModalStatus } from "@/constants/modal";
import { dialogVisibleForStatus } from "@/utils/vue-helpers/modal";
import paymentCardsSvg from "@/assets/images/svg/payment-cards.svg";
import PaymentService, { PaymentServiceStatus } from "@/services/payment-service";
import { defineComponent } from "vue";
import BookingModule from "@/store/modules/booking";
import { PSBErrors } from "@/constants/errors/product-slot-booking";
import { LogLevel, LogService } from "@/services/logging";
import { ref } from "vue";
import { computed } from "vue";
import { ElMessageBox } from "element-plus";
import { useI18n } from "vue-i18n";
import ModalModule from "@/store/modules/modal";
import closeIcon from "@/assets/images/svg/close.svg";
import AppModule from "@/store/modules/app";
import { AdyenResponseStatus } from "@/interfaces/store/IBooking";
import { paymentHandler } from "@/utils/vue-helpers/booking";
import i18n from "@/lang";
export default defineComponent({
  name: ModalComponents.PaymentProgress,
  setup: function setup() {
    var dialogVisible = true || dialogVisibleForStatus(ModalStatus.PaymentProgress);
    var iconContent = paymentCardsSvg;
    var iconStyle = "width: 216px; height: 212px";

    var _useI18n = useI18n({}),
        t = _useI18n.t;

    var showManualPaymentOption = ref(false);
    var timeLeft = ref(10);
    var showManualPaymentModal = ref(false);
    var paymentReference = ref();
    var userInput = ref("");
    var noReceipt = ref(false);
    var showRecieptExampleModal = ref(false);
    var referenceParts = PaymentService.transactionId.split("_");
    var accountingUuid = referenceParts.pop();
    var referencePrefix = referenceParts.join("_") + "_";
    var isMatchingReference = computed(function () {
      return accountingUuid === userInput.value;
    });
    var cantCheckStatus = computed(function () {
      return PaymentService.status === PaymentServiceStatus.CantCheckStatus;
    });
    return {
      dialogVisible: dialogVisible,
      iconContent: iconContent,
      iconStyle: iconStyle,
      t: t,
      showManualPaymentOption: showManualPaymentOption,
      showManualPaymentModal: showManualPaymentModal,
      paymentReference: paymentReference,
      userInput: userInput,
      noReceipt: noReceipt,
      referencePrefix: referencePrefix,
      accountingUuid: accountingUuid,
      isMatchingReference: isMatchingReference,
      showRecieptExampleModal: showRecieptExampleModal,
      cantCheckStatus: cantCheckStatus,
      closeIcon: closeIcon,
      timeLeft: timeLeft
    };
  },
  mounted: function mounted() {
    var _this = this;

    // show manual completion button after 10s
    var timerInterval = setInterval(function () {
      if (_this.timeLeft > 0) {
        _this.timeLeft--;
      } else {
        clearInterval(timerInterval);
        _this.showManualPaymentOption = true;
      }
    }, 1000);
  },
  methods: {
    abortPayment: function abortPayment() {
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var _BookingModule$select;

        var selectedBooking;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                LogService.info("User clicked to abort Adyen payment, booking: ".concat((_BookingModule$select = BookingModule.selectedBooking) === null || _BookingModule$select === void 0 ? void 0 : _BookingModule$select.uuid));
                selectedBooking = BookingModule.selectedBooking;

                if (selectedBooking) {
                  _context.next = 5;
                  break;
                }

                LogService.info("".concat(PSBErrors.NoBookingInModule, " when trying to abort payment ").concat(PaymentService.transactionId), undefined, LogLevel.Error);
                throw new Error(PSBErrors.NoBookingInModule);

              case 5:
                _context.next = 7;
                return PaymentService.abortPayment(selectedBooking);

              case 7:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    completePaymentManually: function completePaymentManually() {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var selectedBooking;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                LogService.info("User clicked to manually complete Adyen payment: ".concat(PaymentService.transactionId));
                selectedBooking = BookingModule.selectedBooking;

                if (selectedBooking) {
                  _context2.next = 5;
                  break;
                }

                LogService.info("".concat(PSBErrors.NoBookingInModule, " when trying to manually complete payment ").concat(PaymentService.transactionId), undefined, LogLevel.Error);
                throw new Error(PSBErrors.NoBookingInModule);

              case 5:
                if (_this2.accountingUuid === _this2.userInput) {
                  // the user entered a correct reference, let's proceed with completing the payment manually
                  PaymentService.completePaymentManually(selectedBooking);
                } else if (_this2.noReceipt) {
                  ElMessageBox.confirm(_this2.t("payment.manual-payment-warning"), {
                    type: "warning",
                    dangerouslyUseHTMLString: true,
                    customClass: "custom-message-box",
                    showClose: false,
                    closeOnClickModal: false,
                    closeOnPressEscape: false,
                    confirmButtonText: "".concat(_this2.t("button.confirm")),
                    cancelButtonText: "".concat(_this2.t("button.cancel"))
                  }).then(function () {
                    LogService.info("User confirmed completing the payment manually without the payment reference, payment: ".concat(PaymentService.transactionId));
                    PaymentService.completePaymentManually(selectedBooking);
                  }).catch(function () {
                    LogService.info("User did not confirm completing the payment manually, payment: ".concat(PaymentService.transactionId));
                  });
                }

              case 6:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    toggleManualPaymentModal: function toggleManualPaymentModal(value) {
      this.showManualPaymentModal = value;
    },
    close: function close() {
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var confirmClosing, selectedBooking, selectedBookingAdyenReponseStatusTrack;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return new Promise(function (resolve) {
                  LogService.info("Prompting user to confirm closing payment progress modal");
                  ElMessageBox.confirm(i18n.global.t("payment-modal.confirm-closing-message"), i18n.global.t("payment-modal.confirm-closing-title"), {
                    cancelButtonText: i18n.global.t("button.cancel"),
                    confirmButtonText: i18n.global.t("payment-modal.confirm"),
                    type: "warning",
                    showClose: false
                  }).then(function () {
                    resolve(true);
                  }).catch(function () {
                    resolve(false);
                  });
                });

              case 2:
                confirmClosing = _context3.sent;

                if (confirmClosing) {
                  _context3.next = 6;
                  break;
                }

                LogService.info("User did not confirm closing payment progress modal");
                return _context3.abrupt("return");

              case 6:
                selectedBooking = BookingModule.selectedBooking;

                if (!(!selectedBooking || !selectedBooking.uuid)) {
                  _context3.next = 10;
                  break;
                }

                LogService.info("".concat(PSBErrors.NoBookingInModule, " when trying to close adyen payment modal ").concat(PaymentService.transactionId), null, LogLevel.Error);
                throw new Error(PSBErrors.NoBookingInModule);

              case 10:
                LogService.info("User clicked to close the Adyen payment modal, booking: ".concat(selectedBooking.uuid));
                selectedBookingAdyenReponseStatusTrack = BookingModule.selectedBookingAdyenReponseStatusTrack;

                if (selectedBookingAdyenReponseStatusTrack[PaymentService.serviceId] === AdyenResponseStatus.Initiated) {
                  // if the user closes the modal because they had no response from the terminal and the payment wasn't completed, we report it as unresponsive
                  // and we remove the accounting
                  LogService.info("Current service ID status was initiated but never completed, marking the payment as failed", {
                    serviceID: PaymentService.serviceId
                  });
                  BookingModule.setAdyenResponseStatusTrack({
                    bookingUuid: selectedBooking.uuid,
                    accountingUuid: PaymentService.serviceId,
                    status: AdyenResponseStatus.Unresponsive
                  });
                  paymentHandler(PaymentServiceStatus.Failed);
                } else if ([AdyenResponseStatus.InitialPaymentFailed, AdyenResponseStatus.Unresponsive].includes(selectedBookingAdyenReponseStatusTrack[PaymentService.serviceId])) {
                  // if we already received an error or the payment api call was unresponsive, plus the modal still hasn't been closed because paymentStatus also faced problems
                  // then we treat the payment as if it failed, and inform the user.
                  // this also prevents keeping pending accountings in the booking
                  LogService.info("Current service ID status is either unresponsive or failed, marking the payment as failed", {
                    serviceID: PaymentService.serviceId
                  });
                  paymentHandler(PaymentServiceStatus.Failed);
                }

                PaymentService.resetPaymentService();
                ModalModule.setStatus(ModalStatus.Hidden);
                AppModule.updatedIsLoading(false);

              case 16:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }))();
    }
  }
});